var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"control"},[_c('div',{staticClass:"field has-addons"},[_c('div',{staticClass:"control is-expanded"},[_c('input',{staticClass:"input",attrs:{"type":"text","disabled":""},domProps:{"value":_vm.readonlyValue}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }